import { ICollectionMapper } from '../Firestore/ICollectionMapper'
import { IFavoriteList, FavoriteList } from './FavoriteList'

export class FavoriteListMapper implements ICollectionMapper<FavoriteList> {
  map(data: IFavoriteList): FavoriteList {
    const favoriteList = new FavoriteList(data.restaurantCompanyId)
    favoriteList.id = data.id

    favoriteList.entries = data.entries

    return favoriteList
  }

  serialize(object: FavoriteList): IFavoriteList {
    return JSON.parse(JSON.stringify(object))
  }
}
